<script>
import ModelShow from '@/components/models/show'
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import { models } from './data-models'
import appConfig from "@/app.config.json";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Models",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelShow
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('models.singular')) }},
    resourceRoute: {default: 'models'},
    modelVariable: {default: 'model'},
    cardAttrs: {default() { return null }},
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('models.plural')),
      loading: false,
      model: this.modelVariable === 'model' ? models[this.$route.params.key - 1] : {},
      tabIndex: 0,
      pillsIndex: 0,
    }
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('models.plural')),
          href: "/models",
        },
        {
          text: this.model && this.model.id ? this.getModelName() : this.$route.params.key,
          href: `/models/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    // modelsMapped() {
    //   return this.lodash.isEmpty(this.model) ? [] : this.lodash.map(this.model, (value) => {
    //     return this.lodash.map(value, (value, key) => ({
    //       key: ['created_at', 'updated_at', 'description'].includes(key) ? this.lodash.upperFirst(this.$t(`models.${key}`)) : this.lodash.upperFirst(this.$t(`${this.resourceRoute}.${key}`)),
    //       value: value
    //     }))
    //   })
    // },
    tabs() {
      return [
        {
          title: 'model',
          modelMapped: this.lodash.isEmpty(this.model) ? [] : this.lodash.map(this.model, (value) => {
            return this.lodash.map(value, (value, key) => ({
              key: ['created_at', 'updated_at', 'description'].includes(key) ? this.lodash.upperFirst(this.$t(`models.${key}`)) : this.lodash.upperFirst(this.$t(`${this.resourceRoute}.${key}`)),
              value: value
            }))
          })
        }
      ]
    },
    relations() {
      return {
        [this.modelVariable || 'model']: [
          // {
          //   name: 'children',
          //   label: this.lodash.startCase(this.$t('models.children')),
          //   component: null,
          //   props: {},
          //   listeners: {}
          // }
        ]
      }
    }
  },
  methods: {
    getModelKey() {
      return this.model[this.modelKey || 'id'];
    },
    getModelName() {
      return this.model['name'] || this.getModelKey();
    },
    handleBack() {
      this.$router.back();
    },
    handleEdit() {
      this.$router.push({path: `edit`, append: true});
    },
    deleteConfirmAlert() {
      return Swal.fire({
        title: this.$t('Are you sure?'),
        text: this.$t(`You won't be able to revert this!`),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill mx-1',
        cancelButtonClass: 'btn btn-danger btn-fill mx-1',
        confirmButtonText: this.$t('Yes, delete it!'),
        cancelButtonText: this.$t('Cancel'),
        buttonsStyling: false
      })
    },
    deleteSuccessAlert(something) {
      return Swal.fire({
        title: this.$t('Deleted') + '!',
        text: this.$t(`You deleted {something}`, {something}),
        type: 'success',
        confirmButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      })
    },
    failedAlert(error) {
      return Swal.fire({
        title: this.$t('Failed') + '!',
        text: (error.response && (error.response.data || {}).message) || error.message,
        type: 'danger',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    },
    delete() {
      return Promise.resolve({ data: {} })
    },
    handleDelete() {
      this.deleteConfirmAlert().then(result => {
        if (result.value) {
          this.delete()
            .then(() => this.deleteSuccessAlert(this.getModelName()))
            .then(() => this.$router.back())
            .catch((error) => this.failedAlert(error));
        }
      });
    },
    pills(){
      return []
    },
    handlePrint(){
      const pageTitle = document.title;
      const id = this.model[this.modelKey || 'id'];
      document.title = `${this.lodash.startCase(this.$t(this.resourceRoute+'.singular'))}-${id}`;
      window.print();
      document.title = pageTitle;
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" v-show="false"/>
    <div>
      <div class="row">
        <keep-alive>
          <div>
            <b-tabs 
              v-model="tabIndex" 
              align="left"
              active-nav-item-class="text-primary border-0"
              nav-class="border-gray-300 d-print-none w-50"
              class="sub-tabs"
              nav-wrapper-class="d-flex justify-content-end"
            >
            <template #tabs-start>
              <div v-if="pills" style="position: absolute; left: 0" class="back d-flex gap-2">
                  <b-button v-bind:key="key" v-for="(pill, key) in pills()" size="lg" :pressed="true" tag="div" :class="`${pill.active ? 'bg-primary text-white' : 'bg-white text-black'}`" variant="light" v-bind="pill" @click="pill.onClick">{{pill.label}}</b-button>
              </div>
            </template>
              <template 
                v-for="(tab, index) in tabs"
              >
                <b-tab :key="index" :title="tab.title">
                  <model-show
                    :loading="loading"
                    v-bind="$props"
                    :value="model"
                    :model-mapped="tab.modelMapped"
                    @back-click="handleBack"
                    @edit-click="handleEdit"
                    @delete-click="handleDelete"
                    @print-click="handlePrint"
                  ></model-show>
                </b-tab>
              </template>
            </b-tabs>
          </div>
        </keep-alive>        
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
    .sub-tabs {
      .nav-link.active {
        position: relative;
        background: none !important;
      }
      .nav-tabs .nav-link {
        border: none !important;
        margin: 0 !important;
        font-weight: 800;
        color: #6C7589;
      }
      .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
        border: none;
        isolation: unset;
      }
      .nav-link:hover {
        border: none;
      }
      .nav-link.active::after{
        content: '';
        position: absolute;
        width: 26px;
        height: 6px;
        background-color: #0084F3;
        bottom: 0;
        left: 50%;
        right: 50%;
        z-index: 1;
        transform: translateX(-50%);
        border-radius: 10px 10px 0 0;
      }
      .nav-item.back > a {
        display: flex;
        align-items: center;
      }
    }
</style>